import { mapGetters } from 'vuex';
import ImageUrlFallback from '../../../mixins/imageUrlFallback';
import Accounting from '../../../mixins/accounting';
import Tooltip from '../../shared/Tooltip';
import branding from '../../../mixins/branding';
require('../scss/vehicle-visual-summary.scss');

export default {
    name: 'VehicleVisualSummary',
    mixins: [Accounting, ImageUrlFallback, branding],
    props: {
        vehicle: Object,
        currentVehicle: Object,
        currencyIsChanging: Boolean,
        activeProduct: Object,
        labels: Object,
        titlePosition: {
            type: String,
            default: 'top',
        },
    },
    components: {
        'gm-tooltip': Tooltip,
    },
    computed: {
        fuelType() {
            let label = this.vehicle.fuel || '';
            let icon = 'fuel-type-icon.svg';

            if (this.vehicle.fuel === 'Petrol/Diesel') {
                label = this.labels.fuel;
            }

            if (['Hybrid', 'Electric'].indexOf(this.vehicle.fuel) > -1) {
                icon = 'battery-icon.svg';
            }

            return label
                ? {
                      label: label.toLowerCase(),
                      icon,
                  }
                : null;
        },
        loyaltyDiscountApplied() {
            return this.vehicle.loyalty_discount_applied && this.userLoyalty;
        },
        luggageLabel() {
            let luggageTypes = {
                short: [],
                long: [],
            };

            if (this.vehicle.luggage_large) {
                luggageTypes.short.push(this.vehicle.luggage_large + this.labels.luggage.large.short);
                luggageTypes.long.push(`${this.vehicle.luggage_large} ${this.labels.luggage.large.long}`);
            }

            if (this.vehicle.luggage_medium) {
                luggageTypes.short.push(this.vehicle.luggage_medium + this.labels.luggage.medium.short);
                luggageTypes.long.push(`${this.vehicle.luggage_medium} ${this.labels.luggage.medium.long}`);
            }

            if (this.vehicle.luggage_small) {
                luggageTypes.short.push(this.vehicle.luggage_small + this.labels.luggage.small.short);
                luggageTypes.long.push(`${this.vehicle.luggage_small} ${this.labels.luggage.small.long}`);
            }

            return {
                short: luggageTypes.short.join(', '),
                long: luggageTypes.long.join(', '),
            };
        },

        transmission() {
            let label = this.vehicle.transmission || '';
            let icon = 'transmission-manual-icon.svg';
            if (label.length == 0) {
                //no-op
            } else if (label.toLowerCase().indexOf('manual') > -1) {
                label = this.labels.transmission.manual;
            } else {
                label = this.labels.transmission.automatic;
                icon = 'transmission-auto-icon.svg';
            }

            return {
                label: label.toLowerCase(),
                icon,
            };
        },
        ...mapGetters({
            selectedCurrency: 'selectedCurrency',
        }),
    },
    methods: {
        toggleDetails() {
            window.bus.$emit('toggle-drige-go-details');
            this.shouldShowDetails = !this.shouldShowDetails;
        },
    },
    data() {
        return {
            imageErrorUrls: [],
            shouldShowDetails: false,
            url: null,
        };
    },

    template: `
    <div class="vehicle-block card-item">
        <div class="vehicle-header" v-if="titlePosition === 'top'">
            <h5 class="w-100">
                {{ currentVehicle.name }}
            </h5>
            <strong class="amount" v-if="currencyIsChanging">&hellip;</strong>
        </div>
        <div class="vehicle-block-body">
            <div class="image" :style="'background-image:url('+ imageUrl(currentVehicle.image) +')'" v-if="currentVehicle.image">
                <img :src="imageUrl(currentVehicle.image)" alt="" @error="imageLoadFailed(currentVehicle.image)"/>
                <img
                        class="loyalty-medal"
                        :src="userLoyalty.image"
                        :alt="userLoyalty.name"
                        v-if="loyaltyDiscountApplied"
                />
            </div>
            <div class="vehicle-specs-icons expanded">
                <div class="vehicle-spec-item w-100" v-if="currentVehicle.adults">
                    <div class="vehicle-spec-item-icon">
                        <img :src="brandingImagesPath('/images/specs-icons/number-of-passengers-icon.svg')"/>
                    </div>
                    <div class="vehicle-spec-item-description">{{ currentVehicle.adults }}</div>
                </div>
                <div class="vehicle-spec-item w-100" v-if="luggageLabel.short">
                    <gm-tooltip :text="luggageLabel.long" click="enabled">
                        <div class="vehicle-spec-item-icon">
                            <img :src="brandingImagesPath('/images/specs-icons/number-of-bags-icon.svg')" alt="Number of bags"/>
                        </div>
                    </gm-tooltip>
                    <div class="vehicle-spec-item-description">{{ luggageLabel.short }}</div>
                </div>
                <div class="vehicle-spec-item w-100" v-if="currentVehicle.fuel">
                    <div class="vehicle-spec-item-icon">
                        <img :src="brandingImagesPath('/images/specs-icons/' + fuelType.icon)" alt="Fuel type"/>
                    </div>
                    <div class="vehicle-spec-item-description">{{ fuelType.label }}</div>
                </div>
                <div class="vehicle-spec-item w-100" v-if="vehicle.co2 > 0">
                    <div class="vehicle-spec-item-icon">
                        <img :src="brandingImagesPath('/images/specs-icons/co2-icon.svg')" alt="CO2"/>
                    </div>
                    <div class="vehicle-spec-item-description">{{ currentVehicle.co2 }}<sub>2</sub></div>
                </div>
                <div class="vehicle-spec-item w-100" v-if="currentVehicle.air_conditioning">
                    <div class="vehicle-spec-item-icon">
                        <img :src="brandingImagesPath('/images/specs-icons/aircon-icon.svg')" alt="Air con"/>
                    </div>
                    <div class="vehicle-spec-item-description">
                        {{ labels.airCon }}
                    </div>
                </div>
                <div class="vehicle-spec-item w-100" v-if="currentVehicle.transmission">
                    <div class="vehicle-spec-item-icon">
                        <img :src="brandingImagesPath('/images/specs-icons/' + transmission.icon)" alt="Transmission"/>
                    </div>
                    <div class="vehicle-spec-item-description">{{ transmission.label }}</div>
                </div>
            </div>
        </div>
    </div>
    `,
};
